import {AccountShortInfo} from 'src/openapi/admin/models/AccountShortInfo';
import {AlertType} from 'src/openapi/admin/models/AlertType';

export type TimeCompareRequest = {
    startDate: string,
    endDate: string,
    startTime: string,
    endTime: string,
};

export type UpdateAlertRequest = {
    forAllUsers: boolean,
    account: AccountShortInfo | null,
    alertType: AlertType,
    message: string,
    startDate: string,
    endDate: string,
    startTime: string,
    endTime: string,
};

export const DEFAULT_REQUEST: UpdateAlertRequest = {
    forAllUsers: true,
    account: null,
    alertType: AlertType.SHOW_ONCE,
    message: '',
    startDate: '',
    endDate: '',
    startTime: '00:00',
    endTime: '00:00',
};
